module.exports = __webpack_public_path__ + "img/building-icon.86dd6e6f.svg";